import axios from "axios";
import { ICarGroup } from "../../types";
import qs from "qs";

export const getCarGroups = async (params: any): Promise<{
    carGroups: ICarGroup[]
}> => {
    const response = await axios.get('/booking/rule/cargroups', {
        params: { ...params, tenants: params.tenants?.join(',') || "", dealers: params.dealers?.join(',') || "drivalia" },
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
    })
    return response.data;
};